import { render, staticRenderFns } from "./RCA.vue?vue&type=template&id=fc1c892e&scoped=true"
import script from "./RCA.vue?vue&type=script&lang=js"
export * from "./RCA.vue?vue&type=script&lang=js"
import style0 from "./RCA.vue?vue&type=style&index=0&id=fc1c892e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1c892e",
  null
  
)

export default component.exports